// A product purchase's review page (/product/purchase/<id>/review), from
// the review reminder email. Port of v1's page on ReviewPageShell: GET
// /widget/pages/product-purchases/:id/review, POST
// /widget/product-purchases/:id/review (the same body as a booking's
// review, reviewPayload). Pure.

import { isOtherSchool } from "../../school";

export type ProductReviewPage = {
  purchase: { _id: string; buyerName?: string; review?: unknown; school?: unknown } | null;
  product: { _id?: string; name?: string; school?: unknown } | null;
};

/** What the page shows: the purchase isn't found ("doesn't seem to belong
 * to you", as v1), it's another school's (the same words as not found),
 * it's been reviewed already, or the form. */
export function productReviewState(page: ProductReviewPage | null | undefined, businessId: string): "not-mine" | "reviewed" | "form" {
  if (!page?.purchase) return "not-mine";
  if (isOtherSchool(businessId, page.purchase.school, page.product?.school)) return "not-mine";
  return page.purchase.review ? "reviewed" : "form";
}
